import { render, staticRenderFns } from "./againInCom.vue?vue&type=template&id=2f231f1d&scoped=true&"
import script from "./againInCom.vue?vue&type=script&lang=js&"
export * from "./againInCom.vue?vue&type=script&lang=js&"
import style0 from "./againInCom.vue?vue&type=style&index=0&id=2f231f1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f231f1d",
  null
  
)

export default component.exports